import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { RequestSummaryProvider } from "../context/RequestSummaryContext";
import { Container, Row, Col } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import AppBar from "../components/headerNav/HeaderNav";
import { ToolbarContextProvider } from "../context/ToolbarContext";
import { TableViewSelectionContextProvider } from "../context/TableViewSelectionContext";
import Header from "../components/header/Header";
import SummaryHeader from "../components/request-summay/SummaryHeader";
import RequestSummaryTable from "../components/request-summay/RequestSummaryTable";
import { UserContext } from "../context/UserContext";
import _ from "lodash";
import "../styles/summary.scss";
import { getPageTitle, Morph } from "../constants/Text";
import Footer from "../components/footer/Footer";
import CookieConsentBanner from "../components/cookie-consent/CookieConsentBanner";

const RequestSummary = () => {
  const { userRole,isUserLoading } = useContext(UserContext);
  const { search } = useLocation();

  useEffect(() => {
    const requestId = new URLSearchParams(search).get('id');
    document.title = getPageTitle(requestId, Morph.FOUNDRY);
    // Reset title on unmount
    return () => {
      document.title = getPageTitle(Morph.MORPH, Morph.FOUNDRY);
    }
  }, [search]);

  return _.isEmpty(userRole) ? null : (
    <TableViewSelectionContextProvider>
      <RequestSummaryProvider>
        <Container
          fluid
          className="summaryContainer">
          <ToolbarContextProvider>
            <Grid container>
              <AppBar />
              {!isUserLoading && <>
                <Header headingText="Request Summary" mode="Request Summary" />
                <>
                  <Grid
                    item
                    xs={12}>
                    <Row className="m-0 p-0"
                      id={"Summary_header_view"}>
                      <SummaryHeader/>
                    </Row>
                    <Row id={"Summary_detail_view"}>
                      <Col xs={12} id={"summary_column"}>
                        <RequestSummaryTable/>
                      </Col>
                    </Row>
                  </Grid>
                </>
              </>}
            </Grid>
          </ToolbarContextProvider>
        </Container>
        <Footer />
        <CookieConsentBanner />
      </RequestSummaryProvider>
    </TableViewSelectionContextProvider>
  );
};

export default RequestSummary;
